import { render, staticRenderFns } from "./add-common-physicalmodel.vue?vue&type=template&id=371db769&scoped=true"
import script from "./add-common-physicalmodel.vue?vue&type=script&lang=js"
export * from "./add-common-physicalmodel.vue?vue&type=script&lang=js"
import style0 from "./add-common-physicalmodel.vue?vue&type=style&index=0&id=371db769&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371db769",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371db769')) {
      api.createRecord('371db769', component.options)
    } else {
      api.reload('371db769', component.options)
    }
    module.hot.accept("./add-common-physicalmodel.vue?vue&type=template&id=371db769&scoped=true", function () {
      api.rerender('371db769', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/physicalmodel/add-common-physicalmodel.vue"
export default component.exports